module.exports = __webpack_public_path__ + "img/s1-2-ja.03fa1edc.jpg";